'use strict';

/* eslint max-lines: 0 */
/* eslint max-lines-per-function: 0 */
/* eslint max-statements: 0 */

var Page        = require('stb-component-page'),
    page        = new Page({$node: document.getElementById('pageMain')}),

    dom         = require('spa-dom'),
    keys        = require('stb-keys'),

    Footer       = require('mag-component-footer'),
    PanelSet     = require('mag-component-panel-set'),
    Panel        = require('mag-component-panel'),
    LayoutList   = require('mag-component-layout-list'),

    Provider     = require('mag-data-cacher'),
    app          = require('mag-app'),
    ModalMessage = require('mag-component-modal'),
    RadioList    = require('mag-component-radio-list'),
    Scrollbar    = require('stb-component-scrollbar'),
    // ScrollArea   = require('mag-component-scroll-area'),
    TabItem      = require('spa-component-tab'),

    exit          = require('../components/exit'),
    infoPanel     = require('../components/info.panel'),
    prepareMain   = require('../utils/prepare.main'),
    prepareModal  = require('../utils/prepare.modal'),
    prepareTracks = require('../utils/prepare.tracks'),

    scrollbarList = new Scrollbar(),
    appConfig = app.config,

    checkTime = 24 * 60 * 60,
    types = {
        albums: 1,
        artists: 2,
        tracks: 3,
        playlists: 4
    },
    typeActive = types.albums,
    timers = {},
    localHistory = [],
    requestConfig = {},
    loaded = false,

    getAllLists, changeFavorite,

    panelSet, centralPanel,
    listActionTrack,
    modalActions, modalActionTrack,
    modalActionAlbum, modalActionReset,
    leftPanel, rightPanel,
    audioList, audioPlayList, sortList,
    selectGenre, selectYear,

    leftInput, $playListInput,

    selectType, createListMessage,
    createList,
    selectList, listPlaylist,

    clickFunction, fillInfo,
    getter, noData,
    $headerTitle, $headerAmount,
    defaultTab, playlistTab, footer,
    footerButtons = {
        f1Reset: {
            code: keys.f1,
            title: gettext('Reset filters'),
            action: null
        },
        f1Delete: {
            code: keys.f1,
            title: gettext('Delete'),
            action: function () {
                if ( audioList.$focusItem.data.value && typeActive === types.playlists ) {
                    modalActions.hide();
                    core.notify({
                        title: gettext('Delete playlist'),
                        icon: 'alert',
                        buttons: [
                            {
                                value: gettext('Cancel')
                            },
                            {
                                value: gettext('Confirm'),
                                click: function () {
                                    audioList.$focusItem.value.remove(function () {
                                        getAllLists(true);
                                    });
                                }
                            }
                        ]
                    });
                }
            }
        },
        f2: {
            code: keys.f2,
            title: gettext('Edit'),
            action: function () {
                if ( audioList.$focusItem.data.value ) {
                    footer.hide();
                    if ( typeActive === types.playlists ) {
                        panelSet.blur();
                        createListMessage.show(audioList.$focusItem.value);
                        createListMessage.focus();
                        modalActions.hide();
                    }
                }
            }
        },
        f3: {
            code: keys.f3,
            title: gettext('Add to playlist'),
            action: function () {
                if ( audioList.$focusItem.data.value ) {
                    footer.hide();

                    switch ( typeActive ) {
                        case types.albums:
                        case types.tracks:
                            changeFavorite();
                            break;
                    }
                }
            }
        },
        menu: {
            code: keys.menu,
            action: function () {
                if ( panelSet.focusIndex === 1 && audioList.$focusItem.data.value ) {
                    footer.hide();

                    switch ( typeActive ) {
                        case types.playlists:
                            panelSet.blur();
                            modalActions.show();
                            modalActions.focus();
                            break;

                        case types.tracks:
                            panelSet.blur();
                            modalActionTrack.show();
                            modalActionTrack.focus();
                            break;

                        case types.albums:
                            panelSet.blur();
                            modalActionAlbum.show();
                            modalActionAlbum.focus();
                            break;
                    }
                }
            }
        },
        menuReset: {
            code: keys.menu,
            action: function () {
                if ( panelSet.panels[panelSet.focusIndex] === leftPanel ) {
                    panelSet.blur();
                    footer.hide();
                    modalActionReset.show();
                    modalActionReset.focus();
                }
            }
        },
        lastConfig: []
    };


/**
 * Fill search input.
 */
function fillSearch () {
    leftInput.$body.parentElement.data.value.query = requestConfig.search;
    $playListInput.$body.parentElement.data.value.query = requestConfig.search;

    if ( requestConfig.search ) {
        leftInput.links.$text.innerText = requestConfig.search;
        $playListInput.links.$text.innerText = requestConfig.search;
        leftInput.links.$icon.classList.add('active');
        $playListInput.links.$icon.classList.add('active');
    } else {
        leftInput.links.$text.innerText = leftInput.$body.parentElement.data.value.placeholder;
        $playListInput.links.$text.innerText = leftInput.$body.parentElement.data.value.placeholder;
        leftInput.links.$icon.classList.remove('active');
        $playListInput.links.$icon.classList.remove('active');
    }
}


/**
 * Getter for album list.
 *
 * @param {Function} callback - result handler
 * @param {Object} config - request config
 */
function getterAlbums ( callback, config ) {
    infoPanel.clear();
    app.api.getAlbums(config, function ( error, data, total ) {
        $headerAmount.innerHTML = error ? 0 : total;
        callback(error, prepareMain(data || []), total || 0);
    });
}


/**
 * Getter for artist list.
 *
 * @param {Function} callback - result handler
 * @param {Object} config - request config
 */
function getterArtists ( callback, config ) {
    infoPanel.hideBackInformation();
    app.api.getArtists(config, function ( error, data, total ) {
        $headerAmount.innerHTML = error ? 0 : total;
        callback(error, prepareMain(data || []), total || 0);
    });
}


/**
 * Getter for track list.
 *
 * @param {Function} callback - result handler
 * @param {Object} config - request config
 */
function getterTracks ( callback, config ) {
    infoPanel.clear();
    app.api.getTracks(config, function ( error, data, total ) {
        $headerAmount.innerHTML = error ? 0 : total;
        callback(error, prepareTracks(data || []), total || 0);
    });
}


/**
 * Getter for playlist list.
 *
 * @param {Function} callback - result handler
 * @param {Object} config - request config
 */
function getterList ( callback, config ) {
    infoPanel.clear();
    app.api.getPlaylists(config, function ( error, data, total ) {
        $headerAmount.innerHTML = error ? 0 : total;
        callback(error, prepareMain(data || []), total || 0);
    });
}


/**
 * Getter for track in playlist list.
 *
 * @param {Function} callback - result handler
 * @param {Object} config - request config
 */
function getterTrackList ( callback, config ) {
    infoPanel.clear();
    appConfig.playlistTrack.list.getTracks(config, function ( error, data, total ) {
        $headerAmount.innerHTML = error ? 0 : total;
        callback(error, prepareTracks(data || []), total || 0);
    });
}


/**
 * Prepare list to play.
 *
 * @param {LayoutList} list - list to play
 */
function prepareToPlay ( list ) {
    var activeItem = list.$focusItem,
        name = activeItem.data.items[0].value,
        id = activeItem.value.id;

    /**
     * Play item.
     *
     * @param {boolean} error - error data
     * @param {string} url - uri to play
     */
    function play ( error, url ) {
        var next = null,
            prev = null;

        if ( error ) {
            return;
        }

        if ( list.data.length > 1 ) {
            //name += ' ' + activeItem.textContent;
            if ( list.provider.head + list.provider.pos + list.$focusItem.index + 1 <= list.provider.maxCount ) {
                next = function () {
                    list.move(keys.down);
                    if ( id === list.$focusItem.value.id ) {
                        app.api.playerContext = null;
                        app.api.intent.close();
                    } else {
                        prepareToPlay(list);
                    }
                };
            }

            if (
                list.provider.head > 0 ||
                list.provider.pos > ( list.provider.headItem ? 1 : 0 ) ||
                list.$focusItem.index > ( list.provider.headItem ? 1 : 0 )
            ) {
                prev = function () {
                    list.move(keys.up);
                    if ( id === list.$focusItem.value.id ) {
                        app.api.playerContext = null;
                        app.api.intent.close();
                    } else {
                        prepareToPlay(list);
                    }
                };
            }

        }
        //play intent
        app.api.intent = core.intent({
            action: 'play',
            mime: 'content/audio',
            data: {
                title: name,
                uri: url,
                mediaId: id
            },
            events: {
                end: function () {
                    if ( next ) {
                        next();
                    } else {
                        app.api.playerContext = null;
                        app.api.intent.close();
                    }
                },
                stop: function () {
                    app.api.playerContext = null;
                    app.api.intent.close();
                },
                error: function () {
                    if ( next ) {
                        next();
                    } else {
                        app.api.playerContext = null;
                        app.api.intent.close();
                    }
                },
                next: next,
                prev: prev
            },
            context: app.api.playerContext
        }, function ( error, context ) {
            if ( error ) {
                debug.fail('Play error', error);
            }
            app.api.playerContext = context;
        });
    }

    if ( !activeItem.value ) {
        return;
    }

    if ( activeItem.value.url ) {
        play(false, activeItem.value.url);
    } else {
        app.api.link(play, {id: activeItem.value.id});
    }
}


/**
 * Create list to play from focus item data.
 */
function createListToPlay () {
    var activeItem = audioList.$focusItem;

    if ( !activeItem.value ) {
        return;
    }

    switch ( typeActive ) {
        case types.albums:
            appConfig.tracks.albumId = activeItem.value.id;
            appConfig.tracks.offset = 0;
            audioPlayList = new LayoutList({
                provider: new Provider({
                    pageSize: appConfig.provider.size,
                    cacheSize: appConfig.provider.pages,
                    request: appConfig.tracks,
                    getter: function ( callback, config ) {
                        app.api.getTracks(config, function ( error, data, total ) {
                            callback(error, prepareTracks(data), total);
                        });
                    },
                    cycle: false
                }),
                scroll: null,
                events: {},
                size: appConfig.provider.size,
                fixedData: true,
                className: 'padded audioList',
                focusIndex: 0
            });
            if ( DEVELOP ) {
                window.audioPlayList = audioPlayList;
            }
            // audioPlayList.once('data:error', function () {
            //     console.log('data:error');
            // });
            audioPlayList.once('data:get', function () {
                prepareToPlay(audioPlayList);
            });
            break;

        case types.playlists:
            appConfig.playlistTrack.list = activeItem.value;
            appConfig.playlistTrack.config.offset = 0;
            audioPlayList = new LayoutList({
                provider: new Provider({
                    pageSize: appConfig.provider.size,
                    cacheSize: appConfig.provider.pages,
                    request: appConfig.playlistTrack.config,
                    getter: function ( callback, config ) {
                        appConfig.playlistTrack.list.getTracks(config, callback);
                    },
                    cycle: false
                }),
                scroll: null,
                events: {},
                size: appConfig.provider.size,
                fixedData: true,
                className: 'padded audioList',
                focusIndex: 0
            });

            if ( DEVELOP ) {
                window.audioPlayList = audioPlayList;
            }
            audioPlayList.once('data:get', function () {
                prepareToPlay(audioPlayList);
            });
            break;

        case types.tracks:
            audioPlayList = audioList;
            prepareToPlay(audioPlayList);

            if ( DEVELOP ) {
                window.audioPlayList = audioPlayList;
            }
            break;
    }
}


/**
 * Click in track list. Start play.
 */
function clickTracks () {
    createListToPlay();
}


/**
 * Click in album list. Enter to album folder.
 *
 * @param {Object} data - item data
 */
function clickAlbums ( data ) {
    localHistory.push({
        provider: audioList.provider,
        focus: audioList.$focusItem.index,
        title: $headerTitle.innerText,
        type: types.albums
    });
    $headerTitle.innerText = data.name;
    typeActive = types.tracks;
    appConfig.tracks.artistId = '';
    appConfig.tracks.albumId = data.id;
    fillInfo = infoPanel.fillTracks;
    getter = getterTracks;
    clickFunction = clickTracks;
    requestConfig = appConfig.tracks;
    requestConfig.offset = 0;
    noData = gettext('No tracks');

    leftInput.$body.parentElement.data.value.query = requestConfig.search;
    $playListInput.$body.parentElement.data.value.query = requestConfig.search;

    fillSearch();

    footer.hide();
    footer.init(footerButtons.lastConfig = {
        left: footerButtons.menu,
        middle: [footerButtons.f3]
    });

    audioList.init({
        provider: new Provider({
            pageSize: appConfig.provider.size,
            cacheSize: appConfig.provider.pages,
            request: requestConfig,
            getter: getter,
            checkTime: requestConfig.search ? 0 : checkTime,
            cycle: true,
            headItem: {
                items: [
                    {
                        className: 'theme-icon theme-icon-back'
                    },
                    {
                        className: 'title',
                        value: '. .'
                    }
                ],
                value: null
            }
        }),
        focusIndex: 0,
        noData: noData
    });
}


/**
 * Click in artist list. Enter to artist folder.
 *
 * @param {Object} data - item data
 */
function clickArtists ( data ) {
    localHistory.push({
        provider: audioList.provider,
        focus: audioList.$focusItem.index,
        title: $headerTitle.innerText,
        type: types.artists
    });

    $headerTitle.innerText = data.name;
    typeActive = types.albums;
    appConfig.albums.artistId = data.id;
    requestConfig = appConfig.albums;
    requestConfig.offset = 0;
    getter = getterAlbums;
    noData = gettext('No albums');
    clickFunction = clickAlbums;
    fillInfo = infoPanel.fillAlbums;
    fillSearch();

    audioList.init({
        provider: new Provider({
            pageSize: appConfig.provider.size,
            cacheSize: appConfig.provider.pages,
            request: requestConfig,
            getter: getter,
            checkTime: requestConfig.search ? 0 : checkTime,
            cycle: true,
            headItem: {
                items: [
                    {
                        className: 'theme-icon theme-icon-back'
                    },
                    {
                        className: 'title',
                        value: '. .'
                    }
                ],
                value: null
            }
        }),
        focusIndex: 0,
        noData: noData
    });
}


/**
 * Click in playlist list. Enter to playlist.
 *
 *
 * @param {Object} data - item data
 */
function clickList ( data ) {
    // var data = e.$item.data.value;

    localHistory.push({
        provider: audioList.provider,
        focus: audioList.$focusItem.index,
        title: $headerTitle.innerText,
        type: types.playlists
    });

    fillSearch();

    $headerTitle.innerText = data.name;
    typeActive = types.tracks;
    appConfig.playlistTrack.list = data;
    fillInfo = infoPanel.fillTracks;
    getter = getterTrackList;
    clickFunction = clickTracks;
    requestConfig = appConfig.playlistTrack.config;
    requestConfig.offset = 0;
    noData = gettext('No tracks');

    listActionTrack.links.addToList.links.$title.innerText = gettext('Remove from playlist');
    footerButtons.f3.title = gettext('Remove from playlist');
    footer.hide();
    footer.init(footerButtons.lastConfig = {
        left: footerButtons.menu,
        middle: [footerButtons.f3]
    });

    audioList.init({
        provider: new Provider({
            pageSize: appConfig.provider.size,
            cacheSize: appConfig.provider.pages,
            request: requestConfig,
            getter: getter,
            checkTime: requestConfig.search ? 0 : checkTime,
            cycle: true,
            headItem: {
                items: [
                    {
                        className: 'theme-icon theme-icon-back'
                    },
                    {
                        className: 'title',
                        value: '. .'
                    }
                ],
                value: null
            }
        }),
        focusIndex: 0,
        noData: noData
    });
}


/**
 * Back function.
 */
function back () {
    var data = localHistory.pop();

    $headerTitle.innerHTML = data.title;
    typeActive = data.type;
    requestConfig.search = '';

    switch ( data.type ) {
        case types.albums:
            requestConfig = appConfig.albums;
            getter = getterAlbums;
            appConfig.albums.artistId = '';
            fillInfo = infoPanel.fillAlbums;
            clickFunction = clickAlbums;
            footerButtons.lastConfig = {
                left: footerButtons.menu,
                middle: [footerButtons.f3]
            };
            noData = gettext('No albums');
            break;

        case types.artists:
            getter = getterArtists;
            fillInfo = infoPanel.fillArtist;
            requestConfig = appConfig.artists;
            clickFunction = clickArtists;
            footerButtons.lastConfig = [];
            noData = gettext('No artists');
            break;

        case types.tracks:
            appConfig.tracks.artistId = '';
            appConfig.tracks.albumId = '';
            fillInfo = infoPanel.fillTracks;
            clickFunction = clickTracks;
            getter = getterTracks;
            requestConfig = appConfig.tracks;
            footerButtons.lastConfig = {
                left: footerButtons.menu,
                middle: [footerButtons.f3]
            };
            noData = gettext('No tracks');
            break;

        case types.playlists:
            fillInfo = infoPanel.fillList;
            clickFunction = clickList;
            getter = getterList;
            noData = gettext('No playlists');
            requestConfig = appConfig.playlist;
            listActionTrack.links.addToList.links.$title.innerText = gettext('Add to playlist');
            footerButtons.f3.title = gettext('Add to playlist');
            footerButtons.lastConfig = {
                left: footerButtons.menu,
                middle: [footerButtons.f1Delete, footerButtons.f2]
            };
            break;
    }

    footer.hide();
    footer.init(footerButtons.lastConfig);
    requestConfig.offset = 0;
    fillSearch();

    audioList.init({
        provider: new Provider({
            pageSize: appConfig.provider.size,
            cacheSize: appConfig.provider.pages,
            request: requestConfig,
            checkTime: requestConfig.search ? 0 : checkTime,
            cycle: true,
            getter: getter
        }),
        focusIndex: data.focus,
        noData: noData
    });
}


/**
 * Refresh audioList data.
 *
 * @param {boolean} remove - has removed item
 */
function refreshAudioList ( remove ) {
    var index = audioList.$focusItem ? audioList.$focusItem.index : 0;

    if ( remove && audioList.provider.botEmptyLine && audioList.$focusItem.index === audioList.data.length - 1 ) {
        index = audioList.$focusItem.index - 1;
        if ( audioList.provider.pos > 0 ) {
            audioList.provider.pos--;
        }
    }

    requestConfig.offset = audioList.provider.head;
    audioList.setData({data: []});
    audioList.init({
        provider: new Provider({
            pageSize: appConfig.provider.size,
            cacheSize: appConfig.provider.pages,
            pos: audioList.provider.pos,
            request: requestConfig,
            getter: getter,
            checkTime: requestConfig.search ? 0 : checkTime,
            cycle: true,
            headItem: audioList.provider.headItem
        }),
        focusIndex: index,
        noData: noData
    });
}


/**
 * Add/remove to/from  playlist.
 */
changeFavorite = function () {
    var data = audioList.$focusItem.value;

    if ( data ) {
        if ( requestConfig === appConfig.playlistTrack.config ) {
            appConfig.playlistTrack.list.removeTrack(data.id, function () {
                refreshAudioList(true);
            });
        } else {
            panelSet.blur();
            selectList.show();
            selectList.focus();
        }
    }
};


/**
 * Get playlist.
 *
 * @param {boolean} remove - has removed item
 */
getAllLists = function ( remove ) {
    app.api.getAllPlaylists(function ( error, data ) {
        var result = prepareModal(data) || [];

        if ( error ) {
            debug.fail('Get all playlists error', error);
        }
        result.push({
            items: [
                {
                    className: 'theme-icon theme-icon-plus'
                },
                {
                    className: 'title',
                    value: gettext('Create playlist')
                }
            ],
            value: null
        });

        listPlaylist.init({
            data: result,
            focusIndex: 0,
            size: result.length < app.metrics.modalSize ? result.length : app.metrics.modalSize
        });
        if ( requestConfig === appConfig.playlist ) {
            refreshAudioList(remove);
        }
    });
};


core.addListener('show', function () {
    app.api.playerContext = null;
});


/**
 * Init page.
 */
page.once('show', function () {
    var modalScroll = new Scrollbar(),
        editMode = false,
        genreList, yearList, inputListName,
        addValue, defaultTabList, playlistTabList;

    /**
     * Finish step of load data. Load filters variation.
     */
    function loadDone () {
        audioList.removeListener('data:error', loadDone);
        audioList.removeListener('data:get', loadDone);

        audioList.focus();

        /**
         * Load genre and init genre modal.
         *
         * @param {boolean} error flag
         * @param {Object} data request
         */
        app.api.getGenres(function ( error, data ) {
            var result = [],
                index;

            if ( error ) {
                debug.fail('Get genre error', error);
            }
            data = data.data || [];
            result.push({
                state: true,
                title: gettext('All genres'),
                value: ''
            });

            for ( index = 0; index < data.length; index++ ) {
                result.push({
                    state: false,
                    title: data[index].name,
                    value: data[index].id
                });
            }
            modalScroll = new Scrollbar();
            selectGenre = new ModalMessage({
                visible: false,
                title: gettext('Genres'),
                events: {
                    show: function () {
                        this.children[0].focus();
                    }
                },
                children: [
                    genreList = new RadioList({
                        focusIndex: 0,
                        size: result.length < app.metrics.modalSize ? result.length : app.metrics.modalSize,
                        data: result,
                        cycle: true,
                        scroll: modalScroll,
                        events: {
                            'click:item': function () {
                                selectGenre.hide();
                                panelSet.focus();
                            },
                            select: function ( event ) {
                                defaultTabList.$focusItem.layout.links.$text.innerText = event.$curr.data.title;
                                if ( event.$curr.data.value ) {
                                    defaultTabList.$focusItem.layout.links.$icon.classList.add('active');
                                } else {
                                    defaultTabList.$focusItem.layout.links.$icon.classList.remove('active');
                                }
                                appConfig.albums.genreId = event.$curr.data.value;
                                appConfig.tracks.genreId = event.$curr.data.value;
                                appConfig.artists.genreId = event.$curr.data.value;
                                requestConfig.offset = 0;
                                audioList.init({
                                    provider: new Provider({
                                        pageSize: appConfig.provider.size,
                                        cacheSize: appConfig.provider.pages,
                                        request: requestConfig,
                                        getter: getter,
                                        checkTime: requestConfig.search ? 0 : checkTime,
                                        cycle: true,
                                        headItem: audioList.provider.headItem
                                    }),
                                    focusIndex: 0,
                                    noData: noData
                                });
                            },
                            keydown: function ( event ) {
                                RadioList.prototype.defaultEvents.keydown.call(this, event);
                                switch ( event.code ) {
                                    case keys.back:
                                        selectGenre.hide();
                                        panelSet.focus();
                                        event.stop = true;
                                        break;
                                }
                            }
                        }
                    }),
                    modalScroll
                ]
            });
            page.add(selectGenre);

            /**
             * Load years and init years modal.
             *
             * @param {boolean} error flag
             * @param {Object} years request
             */
            app.api.getYears(function ( error, years ) {
                result = [];

                if ( error ) {
                    debug.fail('Get years error', error);
                }
                years = years.data || [];
                result.push({
                    state: true,
                    title: gettext('All years'),
                    value: ''
                });

                for ( index = 0; index < years.length; index++ ) {
                    result.push({
                        state: false,
                        title: years[index].name,
                        value: years[index].id
                    });
                }
                modalScroll = new Scrollbar();
                selectYear = new ModalMessage({
                    visible: false,
                    title: gettext('Years'),
                    events: {
                        show: function () {
                            this.children[0].focus();
                        }
                    },
                    children: [
                        yearList = new RadioList({
                            focusIndex: 0,
                            size: result.length < app.metrics.modalSize ? result.length : app.metrics.modalSize,
                            cycle: true,
                            scroll: modalScroll,
                            data: result,
                            events: {
                                'click:item': function () {
                                    selectYear.hide();
                                    panelSet.focus();
                                },
                                select: function ( event ) {
                                    defaultTabList.$focusItem.layout.links.$text.innerText = event.$curr.data.title;
                                    if ( event.$curr.data.value ) {
                                        defaultTabList.$focusItem.layout.links.$icon.classList.add('active');
                                    } else {
                                        defaultTabList.$focusItem.layout.links.$icon.classList.remove('active');
                                    }
                                    appConfig.albums.yearId = event.$curr.data.value;
                                    appConfig.tracks.yearId = event.$curr.data.value;
                                    appConfig.artists.yearId = event.$curr.data.value;
                                    requestConfig.offset = 0;
                                    audioList.init({
                                        provider: new Provider({
                                            pageSize: appConfig.provider.size,
                                            cacheSize: appConfig.provider.pages,
                                            request: requestConfig,
                                            getter: getter,
                                            checkTime: requestConfig.search ? 0 : checkTime,
                                            cycle: true,
                                            headItem: audioList.provider.headItem
                                        }),
                                        focusIndex: 0,
                                        noData: noData
                                    });
                                },
                                keydown: function ( event ) {
                                    RadioList.prototype.defaultEvents.keydown.call(this, event);
                                    switch ( event.code ) {
                                        case keys.back:
                                            selectYear.hide();
                                            panelSet.focus();
                                            event.stop = true;
                                            break;
                                    }
                                }
                            }
                        }),
                        modalScroll
                    ]
                });
                page.add(selectYear);
                getAllLists();
            });
        });

        app.ready();
    }

    /**
     * Search function. Init keyboard and set result.
     */
    function clickSearch () {
        core.intent({
            action: 'keyboard',
            data: {
                value: leftInput.$body.parentElement.data.value.query,
                title: gettext('AUDIO SEARCH')
            },
            events: {
                done: function ( data ) {
                    if ( requestConfig.search !== data.value ) {
                        requestConfig.search = data.value;
                        fillSearch();
                        audioList.init({
                            provider: new Provider({
                                pageSize: appConfig.provider.size,
                                cacheSize: appConfig.provider.pages,
                                request: requestConfig,
                                getter: getter,
                                checkTime: requestConfig.search ? 0 : checkTime,
                                cycle: true,
                                headItem: audioList.provider.headItem
                            }),
                            focusIndex: 0,
                            noData: noData
                        });
                    }

                }
            }
        }, function ( error ) {
            debug.fail('Keyboard return', error);
        });
    }

    footer = new Footer({visible: false, parent: page});
    footerButtons.lastConfig = {
        left: footerButtons.menu,
        middle: [footerButtons.f3]
    };
    footer.init([]);

    //init left default list
    defaultTab = new TabItem({
        propagate: true,
        focusable: true,
        children: [
            defaultTabList = new LayoutList({
                focusIndex: 0,
                size: 6,
                cycle: true,
                data: [
                    {
                        name: 'search',
                        items: [
                            {
                                name: '$icon',
                                className: 'theme-icon theme-icon-search'
                            },
                            {
                                name: '$text',
                                value: gettext('Search'),
                                className: 'inputSearchField'
                            }
                        ],
                        value: {
                            placeholder: gettext('Search'),
                            query: ''
                        },
                        click: clickSearch
                    },
                    {
                        name: 'category',
                        items: [
                            {
                                name: '$icon',
                                className: 'theme-icon theme-icon-categories'
                            },
                            {
                                name: '$text',
                                value: gettext('Albums'),
                                className: 'theme-item-more'
                            }
                        ],
                        click: function () {
                            panelSet.blur();
                            selectType.show();
                            selectType.focus();
                        }
                    },
                    {
                        name: 'genre',
                        items: [
                            {
                                name: '$icon',
                                className: 'theme-icon theme-icon-genres'
                            },
                            {
                                name: '$text',
                                value: gettext('All genres'),
                                className: 'theme-item-more'
                            }
                        ],
                        click: function () {
                            panelSet.blur();
                            selectGenre.show();
                            selectGenre.focus();
                        }
                    },
                    {
                        name: 'year',
                        items: [
                            {
                                name: '$icon',
                                className: 'theme-icon theme-icon-filter'
                            },
                            {
                                name: '$text',
                                value: gettext('All years'),
                                className: 'theme-item-more'
                            }
                        ],
                        click: function () {
                            panelSet.blur();
                            selectYear.show();
                            selectYear.focus();
                        }
                    },
                    {
                        name: 'sort',
                        items: [
                            {
                                name: '$icon',
                                className: 'theme-icon theme-icon-sort-az'
                            },
                            {
                                name: '$text',
                                value: gettext('By date'),
                                className: 'theme-item-more'
                            }
                        ],
                        click: function () {
                            panelSet.blur();
                            sortList.show();
                            sortList.focus();
                        }
                    },
                    {
                        items: [
                            {
                                className: 'theme-icon theme-icon-exit'
                            },
                            {
                                value: gettext('Exit')
                            }
                        ],
                        click: function () {
                            exit.goExit();
                        }
                    }
                ],
                events: {
                    keydown: function ( event ) {
                        LayoutList.prototype.defaultEvents.keydown.call(this, event);
                        switch ( event.code ) {
                            case keys.right:
                                leftPanel.emit('keydown', event);
                                event.stop = true;
                                break;
                        }
                    },
                    blur: function () {
                        LayoutList.prototype.blur.call(this);
                        footer.hide();
                    },
                    focus: function () {
                        footer.init({
                            left: footerButtons.menuReset,
                            middle: [footerButtons.f1Reset]
                        });
                        footer.show();
                    }
                }
            })
        ],
        events: {
            focus: function () {
                defaultTabList.focus();
            }
        }
    });
    leftInput = defaultTabList.links.search;

    //init left list for playlist type
    playlistTab = new TabItem({
        propagate: true,
        focusable: true,
        children: [
            playlistTabList = new LayoutList({
                propagate: true,
                focusIndex: 1,
                cycle: true,
                size: 4,
                data: [
                    {
                        name: 'search',
                        items: [
                            {
                                name: '$icon',
                                className: 'theme-icon theme-icon-search'
                            },
                            {
                                name: '$text',
                                value: gettext('Search'),
                                className: 'inputSearchField'
                            }
                        ],
                        value: {
                            placeholder: gettext('Search'),
                            query: ''
                        },
                        click: clickSearch
                    },
                    {
                        items: [
                            {
                                className: 'theme-icon theme-icon-categories'
                            },
                            {
                                value: gettext('Playlists'),
                                className: 'theme-item-more'
                            }
                        ],
                        click: function () {
                            panelSet.blur();
                            selectType.show();
                            selectType.focus();
                        }
                    },
                    {
                        items: [
                            {
                                className: 'theme-icon theme-icon-plus'
                            },
                            {
                                value: gettext('Create playlist')
                            }
                        ],
                        click: function () {
                            panelSet.blur();
                            createListMessage.show();
                            createListMessage.focus();
                        }
                    },
                    {
                        items: [
                            {
                                className: 'theme-icon theme-icon-exit'
                            },
                            {
                                value: gettext('Exit')
                            }
                        ],
                        click: function () {
                            exit.goExit();
                        }
                    }
                ],
                events: {
                    keydown: function ( event ) {
                        LayoutList.prototype.defaultEvents.keydown.call(this, event);
                        switch ( event.code ) {
                            case keys.right:
                                leftPanel.emit('keydown', event);
                                event.stop = true;
                                break;
                        }
                    },
                    blur: function () {
                        LayoutList.prototype.blur.call(this);
                        footer.hide();
                    },
                    focus: function () {
                        footer.init({
                            left: footerButtons.menuReset,
                            middle: [footerButtons.f1Reset, footerButtons.f2]
                        });
                        footer.show();
                    }
                }
            })
        ],
        events: {
            focus: function () {
                playlistTab.children[0].focus();
            }
        }
    });
    $playListInput = playlistTabList.links.search;

    leftPanel = new Panel({
        title: [
            {
                value: gettext('Menu'),
                className: 'name'
            }
        ],
        children: [defaultTab, playlistTab],
        events: {
            focus: function () {
                if ( this.currentTab ) {
                    this.currentTab.focus();
                } else {
                    Panel.prototype.defaultEvents.focus.call(this);
                }
            }
        }
    });
    defaultTab.show();

    centralPanel = new Panel({
        title: [
            {
                value: gettext('Albums'),
                className: 'name'
            },
            dom.tag(
                'div',
                {className: 'amountContainer'},
                $headerAmount = dom.tag('div', {className: 'amount'}, '0')
            )
        ],
        main: true
    });
    $headerTitle = centralPanel.$title.$node.children[0];

    infoPanel.init();

    rightPanel = new Panel({
        title: [
            {
                value: gettext('Info'),
                className: 'name'
            }
        ],
        children: [infoPanel.textArea, infoPanel.textArea.scroll],
        events: {
            focus: function () {
                Panel.prototype.defaultEvents.focus.call(this);
                footer.hide();
            }
        }
    });
    infoPanel.textArea.init();

    clickFunction = clickAlbums;
    fillInfo = infoPanel.fillAlbums;
    requestConfig = appConfig.albums;
    getter = getterAlbums;
    noData = gettext('No albums');

    audioList = new LayoutList({
        provider: new Provider({
            pageSize: appConfig.provider.size,
            cacheSize: appConfig.provider.pages,
            request: {},
            checkTime: requestConfig.search ? 0 : checkTime,
            getter: getter = getterAlbums,
            cycle: true
        }),
        scroll: scrollbarList,
        events: {
            focus: function () {
                footer.init(footerButtons.lastConfig);
                if ( audioList.$focusItem && audioList.$focusItem.data.value ) {
                    footer.show();
                } else {
                    footer.hide();
                }
            },

            'focus:item': function ( event ) {
                if ( event.$curr.data.value ) {
                    footer.show();
                } else {
                    footer.hide();
                }
                clearTimeout(timers.info);
                timers.info = setTimeout(function () {
                    fillInfo(event.$curr.data.value);
                }, core.environment.onFocusDebounceTimeout);

            },

            'move:view': function () {
                if ( audioList && audioList.$focusItem ) {
                    if ( audioList.$focusItem.data.value ) {
                        footer.show();
                    } else {
                        footer.hide();
                    }
                    fillInfo(audioList.$focusItem.data.value);
                }
            },

            'click:item': function ( event ) {
                if ( !event.$item.data.value && localHistory.length ) {
                    back();

                    return;
                }
                clickFunction(event.$item.data.value);
            },

            keydown: function ( event ) {
                LayoutList.prototype.defaultEvents.keydown.call(this, event);
                switch ( event.code ) {
                    case keys.playPause:
                        if ( audioList.$focusItem.data.value && typeActive !== types.artists ) {
                            createListToPlay();
                        }
                        break;
                }
            }
        },
        size: appConfig.provider.size,
        className: 'padded audioList',
        noData: noData,
        focusIndex: 0
    });

    audioList.once('data:error', loadDone);
    audioList.once('data:get', loadDone);

    audioPlayList = null;

    panelSet = new PanelSet({
        visible: false,
        panels: [leftPanel, centralPanel, rightPanel]
    });

    page.add(panelSet);

    centralPanel.add(audioList);
    centralPanel.add(scrollbarList);
    centralPanel.focus();

    //init types select
    selectType = new ModalMessage({
        visible: false,
        title: gettext('Categories'),
        events: {
            show: function () {
                this.children[0].focus();
            }
        },
        children: [
            new RadioList({
                focusIndex: 0,
                size: 4,
                cycle: true,
                data: [
                    {
                        state: true,
                        title: gettext('Albums'),
                        value: types.albums
                    },
                    {
                        state: false,
                        title: gettext('Singers'),
                        value: types.artists
                    },
                    {
                        state: false,
                        title: gettext('Tracks'),
                        value: types.tracks
                    },
                    {
                        state: false,
                        title: gettext('Playlists'),
                        value: types.playlists
                    }
                ],
                events: {
                    'click:item': function () {
                        selectType.hide();
                        panelSet.focus();
                    },
                    select: function ( data ) {
                        $headerTitle.innerHTML = data.$curr.data.title;
                        localHistory = [];
                        requestConfig.search = '';

                        switch ( data.$curr.data.value ) {
                            case types.albums:
                                // if ( typeActive === types.playlists ) {
                                defaultTab.show();
                                defaultTab.focus();
                                // }
                                footerButtons.lastConfig = {
                                    left: footerButtons.menu,
                                    middle: [footerButtons.f3]
                                };
                                defaultTabList.$focusItem.layout.links.$text.innerText = data.$curr.data.title;
                                requestConfig = appConfig.albums;
                                getter = getterAlbums;
                                appConfig.albums.artistId = '';
                                fillInfo = infoPanel.fillAlbums;
                                clickFunction = clickAlbums;
                                noData = gettext('No albums');
                                infoPanel.hideHolder();
                                break;

                            case types.artists:
                                // if ( typeActive === types.playlists ) {
                                defaultTab.show();
                                defaultTab.focus();
                                // }
                                footerButtons.lastConfig = [];
                                defaultTabList.$focusItem.layout.links.$text.innerText = data.$curr.data.title;
                                getter = getterArtists;
                                // infoPanel.showContainer();
                                requestConfig = appConfig.artists;
                                fillInfo = infoPanel.fillArtist;
                                clickFunction = clickArtists;
                                noData = gettext('No artists');
                                infoPanel.showHolder();
                                break;

                            case types.tracks:
                                // if ( typeActive === types.playlists ) {
                                defaultTab.show();
                                defaultTab.focus();
                                // }
                                footerButtons.f3.title = gettext('Add to playlist');
                                footerButtons.lastConfig = {
                                    left: footerButtons.menu,
                                    middle: [footerButtons.f3]
                                };
                                defaultTabList.$focusItem.layout.links.$text.innerText = data.$curr.data.title;
                                appConfig.tracks.artistId = '';
                                appConfig.tracks.albumId = '';
                                fillInfo = infoPanel.fillTracks;
                                clickFunction = clickTracks;
                                getter = getterTracks;
                                requestConfig = appConfig.tracks;
                                noData = gettext('No tracks');
                                infoPanel.hideHolder();
                                break;

                            case types.playlists:
                                fillInfo = infoPanel.fillList;
                                clickFunction = clickList;
                                getter = getterList;
                                noData = gettext('No playlists');
                                footerButtons.lastConfig = {
                                    left: footerButtons.menu,
                                    middle: [footerButtons.f1Delete, footerButtons.f2]
                                };
                                requestConfig = appConfig.playlist;
                                playlistTab.show();
                                playlistTab.focus();
                                infoPanel.showHolder();
                                break;
                        }

                        typeActive = data.$curr.data.value;
                        requestConfig.offset = 0;
                        fillSearch();

                        audioList.init({
                            provider: new Provider({
                                pageSize: appConfig.provider.size,
                                cacheSize: appConfig.provider.pages,
                                request: requestConfig,
                                checkTime: requestConfig.search ? 0 : checkTime,
                                cycle: true,
                                getter: getter
                            }),
                            focusIndex: 0,
                            noData: noData
                        });
                    },
                    keydown: function ( event ) {
                        RadioList.prototype.defaultEvents.keydown.call(this, event);
                        switch ( event.code ) {
                            case keys.back:
                                selectType.hide();
                                panelSet.focus();
                                event.stop = true;
                                break;
                        }
                    }
                }
            })
        ]
    });
    page.add(selectType);

    //init playlist select
    modalScroll = new Scrollbar();
    selectList = new ModalMessage({
        visible: false,
        title: gettext('Playlists'),
        events: {
            show: function () {
                footer.hide();
                this.children[0].focus();
            }
        },
        children: [
            listPlaylist = new LayoutList({
                focusIndex: 0,
                size: app.metrics.modalSize,
                cycle: true,
                scroll: modalScroll,
                events: {
                    'click:item': function ( data ) {
                        data = data.$item.data.value;
                        selectList.hide();

                        if ( data ) {
                            switch ( typeActive ) {
                                case types.tracks:
                                    data.addTrack(audioList.$focusItem.value.id);
                                    break;

                                case types.albums:
                                    data.addAlbum(audioList.$focusItem.value.id);
                                    break;
                            }
                            panelSet.focus();
                        } else {
                            addValue = true;
                            createListMessage.show();
                            createListMessage.focus();
                        }
                    },
                    keydown: function ( event ) {
                        RadioList.prototype.defaultEvents.keydown.call(this, event);
                        switch ( event.code ) {
                            case keys.back:
                                selectList.hide();
                                panelSet.focus();
                                event.stop = true;
                                break;
                        }
                    }
                }
            }),
            modalScroll
        ]
    });
    page.add(selectList);

    //init sort list
    modalScroll = new Scrollbar();
    sortList = new ModalMessage({
        visible: false,
        title: gettext('Sort'),
        events: {
            show: function () {
                this.children[0].focus();
            }
        },
        children: [
            new RadioList({
                focusIndex: 0,
                size: 2,
                cycle: true,
                data: [
                    {
                        state: true,
                        title: gettext('By date'),
                        value: 'added'
                    },
                    {
                        state: false,
                        title: gettext('By name'),
                        value: 'name'
                    }
                ],
                events: {
                    'click:item': function () {
                        sortList.hide();
                        panelSet.focus();
                    },
                    select: function ( data ) {
                        defaultTabList.$focusItem.layout.links.$text.innerText = data.$curr.data.title;
                        appConfig.albums.sortby = data.$curr.data.value;
                        appConfig.tracks.sortby = data.$curr.data.value;
                        audioList.init({
                            provider: new Provider({
                                pageSize: appConfig.provider.size,
                                cacheSize: appConfig.provider.pages,
                                request: requestConfig,
                                getter: getter,
                                checkTime: requestConfig.search ? 0 : checkTime,
                                cycle: true,
                                headItem: audioList.provider.headItem
                            }),
                            focusIndex: 0,
                            noData: noData
                        });
                    },
                    keydown: function ( event ) {
                        RadioList.prototype.defaultEvents.keydown.call(this, event);
                        switch ( event.code ) {
                            case keys.back:
                                sortList.hide();
                                panelSet.focus();
                                event.stop = true;
                                break;
                        }
                    }
                }
            })
        ]
    });
    page.add(sortList);

    //init create playlist
    createListMessage = new ModalMessage({
        title: gettext('create playlist'),
        events: {
            show: function ( data ) {
                // createList.setData({focusIndex: 0});
                createList.focusIndex(0);
                footer.hide();
                if ( data ) {
                    editMode = data;
                    inputListName.$parentItem.data.value.name = data.name;
                    inputListName.links.$text.innerText = data.name;
                    this.$text.innerText = gettext('edit playlist');
                    createList.links.button.links.$text.innerText = gettext('Edit');
                    createList.links.button.data[0].value = gettext('Edit');
                } else {
                    editMode = false;
                    inputListName.$parentItem.data.value.name = '';
                    inputListName.links.$text.innerText = inputListName.$parentItem.data.value.placeholder;
                    this.$text.innerText = gettext('create playlist');
                    createList.links.button.links.$text.innerText = gettext('Create');
                    createList.links.button.data[0].value = gettext('Create');
                }
                createList.$focusItem.data.click();
            }
        },
        children: [
            createList = new LayoutList({
                className: 'padded',
                size: 2,
                cycle: true,
                data: [
                    {
                        name: 'name',
                        items: [
                            {
                                name: '$text',
                                value: gettext('name'),
                                className: 'title center'
                            }
                        ],
                        value: {
                            placeholder: gettext('name'),
                            name: ''
                        },
                        click: function () {
                            core.intent({
                                action: 'keyboard',
                                data: {
                                    value: inputListName.$parentItem.data.value.name,
                                    title: editMode ? gettext('edit playlist') : gettext('create playlist'),
                                    placeholder: inputListName.$parentItem.data.value.placeholder
                                },
                                events: {
                                    done: function ( event ) {
                                        createList.focusIndex(1);
                                        inputListName.$parentItem.data.value.name = event.value;
                                        if ( event.value ) {
                                            inputListName.links.$text.innerText = event.value;
                                        } else {
                                            inputListName.links.$text.innerText = inputListName.$parentItem.data.value.placeholder;
                                        }
                                    }
                                }
                            }, function ( error ) {
                                debug.fail('Keyboard return', error);
                            });
                        }
                    },
                    {
                        name: 'button',
                        items: [
                            {
                                name: '$text',
                                value: editMode ? gettext('Edit') : gettext('Create'),
                                className: 'title center'
                            }
                        ],
                        click: function () {
                            createListMessage.hide();
                            panelSet.focus();
                            if ( editMode === false ) {
                                app.api.createPlaylist({
                                    name: inputListName.$parentItem.data.value.name
                                }, function ( error, data ) {
                                    if ( error ) {
                                        return;
                                    }

                                    if ( addValue ) {
                                        addValue = false;
                                        switch ( typeActive ) {
                                            case types.tracks:
                                                data.addTrack(audioList.$focusItem.value.id);
                                                break;

                                            case types.albums:
                                                data.addAlbum(audioList.$focusItem.value.id);
                                                break;
                                        }
                                    }

                                    getAllLists();
                                });
                            } else {
                                editMode.edit(inputListName.$parentItem.data.value.name, getAllLists);
                            }
                        }
                    }
                ],
                events: {
                    keydown: function ( event ) {
                        LayoutList.prototype.defaultEvents.keydown.call(this, event);
                        switch ( event.code ) {
                            case keys.back:
                                createListMessage.hide();
                                panelSet.focus();
                                event.stop = true;
                                break;
                        }
                    }
                }
            })
        ]
    });
    inputListName = createList.links.name;
    page.add(createListMessage);

    /**
     * Reset filters to default values.
     */
    footerButtons.f1Reset.action = function () {
        var links = defaultTabList.links;

        if ( genreList.$checkedData ) {
            genreList.$checkedData.state = false;
            genreList.data[0].state = true;
        }
        genreList.setData({data: genreList.data, focusIndex: 0});
        if ( yearList.$checkedData ) {
            yearList.$checkedData.state = false;
            yearList.data[0].state = true;
        }
        yearList.setData({data: yearList.data, focusIndex: 0});

        appConfig.artists.search = '';
        appConfig.artists.genreId = '';
        appConfig.artists.yearId = '';

        appConfig.albums.genreId = '';
        appConfig.albums.yearId = '';
        appConfig.albums.search = '';

        appConfig.tracks.genreId = '';
        appConfig.tracks.yearId = '';
        appConfig.tracks.search = '';

        appConfig.playlist.search = '';

        appConfig.playlistTrack.config.search = '';

        fillSearch();

        links.genre.links.$text.innerText = gettext('All genres');
        links.year.links.$text.innerText = gettext('All years');
        links.search.links.$icon.classList.remove('active');
        links.genre.links.$icon.classList.remove('active');
        links.year.links.$icon.classList.remove('active');
        requestConfig.offset = 0;
        requestConfig.limit = 0;
        audioList.init({
            provider: new Provider({
                pageSize: appConfig.provider.size,
                cacheSize: appConfig.provider.pages,
                request: requestConfig,
                checkTime: requestConfig.search ? 0 : checkTime,
                cycle: true,
                getter: getter,
                headItem: audioList.provider.headItem
            }),
            focusIndex: 0,
            noData: noData
        });
    };

    //playlist type action modal
    page.add(
        modalActions = new ModalMessage({
            title: gettext('Actions'),
            events: {
                hide: function () {
                    panelSet.focus();
                }
            },
            children: [
                new LayoutList({
                    size: 2,
                    focusIndex: 0,
                    cycle: true,
                    data: [
                        {
                            items: [
                                {
                                    className: 'theme-icon theme-icon-rc-f1'
                                },
                                {
                                    value: gettext('Delete')
                                }
                            ],
                            click: function () {
                                modalActions.hide();
                                footerButtons.f1Delete.action();
                            }
                        },
                        {
                            items: [
                                {
                                    className: 'theme-icon theme-icon-rc-f2'
                                },
                                {
                                    value: gettext('Edit')
                                }
                            ],
                            click: function () {
                                modalActions.hide();
                                panelSet.blur();
                                createListMessage.show(audioList.$focusItem.value);
                                createListMessage.focus();
                            }
                        }
                    ],
                    events: {
                        keydown: function ( event ) {
                            LayoutList.prototype.defaultEvents.keydown.call(this, event);
                            switch ( event.code ) {
                                case keys.menu:
                                case keys.back:
                                    modalActions.hide();
                                    event.stop = true;
                                    break;
                            }
                        }
                    }
                })
            ]
        })
    );

    //reset action modal
    page.add(
        modalActionReset = new ModalMessage({
            title: gettext('Actions'),
            events: {
                hide: function () {
                    panelSet.focus();
                }
            },
            children: [
                new LayoutList({
                    size: 1,
                    focusIndex: 0,
                    cycle: true,
                    data: [
                        {
                            items: [
                                {
                                    className: 'theme-icon theme-icon-rc-f1'
                                },
                                {
                                    value: gettext('Reset filters')
                                }
                            ],
                            click: function () {
                                modalActionReset.hide();
                                footerButtons.f1Reset.action();
                            }
                        }
                    ],
                    events: {
                        keydown: function ( event ) {
                            LayoutList.prototype.defaultEvents.keydown.call(this, event);
                            switch ( event.code ) {
                                case keys.menu:
                                case keys.back:
                                    modalActionReset.hide();
                                    event.stop = true;
                                    break;
                            }
                        }
                    }
                })
            ]
        })
    );

    //track type action modal
    page.add(
        modalActionTrack = new ModalMessage({
            title: gettext('Actions'),
            events: {
                show: function () {
                    //this.children[0].focus();
                    clearTimeout(timers.footer);
                    footer.hide();
                },
                hide: function () {
                    panelSet.focus();
                }
            },
            children: [
                listActionTrack = new LayoutList({
                    size: 2,
                    focusIndex: 0,
                    cycle: true,
                    data: [
                        {
                            name: 'play',
                            items: [
                                {
                                    name: '$icon',
                                    className: 'theme-icon theme-icon-rc-play-pause'
                                },
                                {
                                    name: '$title',
                                    className: 'title',
                                    value: gettext('Play')
                                }
                            ],
                            click: function () {
                                modalActionTrack.hide();
                                createListToPlay();
                            }
                        },
                        {
                            name: 'addToList',
                            items: [
                                {
                                    name: '$icon',
                                    className: 'theme-icon theme-icon-rc-f3'
                                },
                                {
                                    name: '$title',
                                    className: 'title',
                                    value: gettext('Add to playlist')
                                }
                            ],
                            click: function () {
                                modalActionTrack.hide();
                                changeFavorite();
                            }
                        }
                    ],
                    events: {
                        keydown: function ( event ) {
                            LayoutList.prototype.defaultEvents.keydown.call(this, event);
                            switch ( event.code ) {
                                case keys.menu:
                                case keys.back:
                                    modalActionTrack.hide();
                                    event.stop = true;
                                    break;
                            }
                        }
                    }
                })
            ]
        })
    );

    //album type action modal
    page.add(
        modalActionAlbum = new ModalMessage({
            title: gettext('Actions'),
            events: {
                show: function () {
                    //this.children[0].focus();
                    clearTimeout(timers.footer);
                    footer.hide();
                },
                hide: function () {
                    panelSet.focus();
                }
            },
            children: [
                new LayoutList({
                    size: 2,
                    focusIndex: 0,
                    cycle: true,
                    data: [
                        {
                            items: [
                                {
                                    className: 'theme-icon theme-icon-rc-play-pause'
                                },
                                {
                                    className: 'title',
                                    value: gettext('Play')
                                }
                            ],
                            click: function () {
                                modalActionAlbum.hide();
                                createListToPlay();
                            }
                        },
                        {
                            items: [
                                {
                                    className: 'theme-icon theme-icon-rc-f3'
                                },
                                {
                                    className: 'title',
                                    value: gettext('Add to playlist')
                                }
                            ],
                            click: function () {
                                modalActionAlbum.hide();
                                changeFavorite();
                            }
                        }
                    ],
                    events: {
                        keydown: function ( event ) {
                            LayoutList.prototype.defaultEvents.keydown.call(this, event);
                            switch ( event.code ) {
                                case keys.menu:
                                case keys.back:
                                    modalActionAlbum.hide();
                                    event.stop = true;
                                    break;
                            }
                        }
                    }
                })
            ]
        })
    );

    if ( DEVELOP ) {
        window.leftInput = leftInput;
        window.defaultTabList = defaultTabList;
        window.inputListName = inputListName;
        window.createListMessage = createListMessage;
        window.createList = createList;
        window.audioList = audioList;
        window.listActionTrack = listActionTrack;
        window.modalActionTrack = modalActionTrack;
        window.modalActionAlbum = modalActionAlbum;
    }
});


page.addListeners({
    show: function () {
        panelSet.show();
        panelSet.focus();
        audioPlayList = null;
    },
    keydown: function ( event ) {
        switch ( event.code ) {
            case keys.back:
                //case keys.exit:
                if ( localHistory.length ) {
                    back();
                    event.stop = true;
                    break;
                }
                exit.goBack();
                break;
        }
    }
});


core.addListeners({
    show: function () {
        if ( loaded ) {
            audioPlayList = null;

            if ( requestConfig.search ) {
                return;
            }

            refreshAudioList();
            loaded = true;
        }

    },
    intent: function ( intent, callback ) {
        if ( intent.action === 'audioClub' ) {
            switch ( intent.mime ) {
                case 'info':
                    if ( intent.data ) {
                        clickAlbums(intent.data);
                        callback(false);
                    } else {
                        callback(true);
                    }
                    break;

                default:
                    callback(false);
            }
        }
    }
});


module.exports = page;
